import {
  type ProductOfDayDataType,
  type ProductOfDayRewardItem,
} from '@/common/types/contract';
import { type TicketRewardType } from '@/common/types/lottery';

const getMainReward = (
  reward: ProductOfDayDataType['chestboxReward'],
): ProductOfDayRewardItem | undefined => {
  const rewardArray =
    reward && reward[0] ? Object.entries(reward[0])[0] : undefined;
  const rewardName = rewardArray && rewardArray[0];
  const value = rewardArray && rewardArray[1];

  return rewardName && value
    ? { type: rewardName as TicketRewardType | 'tgem' | 'usdt' | 'dice', value }
    : undefined;
};

const getGuaranterReward = (
  reward: ProductOfDayDataType['chestboxReward'],
): ProductOfDayRewardItem | undefined => {
  const rewardArray =
    reward && reward[1] ? Object.entries(reward[1])[0] : undefined;
  const rewardName = rewardArray && rewardArray[0];
  const value = rewardArray && rewardArray[1];

  return rewardName && value
    ? { type: rewardName as TicketRewardType | 'tgem' | 'usdt' | 'dice', value }
    : undefined;
};

export { getGuaranterReward, getMainReward };
